import { useProposalT } from "../i18n/ProposalI18nContext";

export function FlexibilitySection() {
  const { t } = useProposalT();

  return (
    <section
      className="py-12 px-6"
      style={{ background: "#FDFBF7", borderTop: "1px solid #E8E6E3" }}
    >
      <div style={{ maxWidth: "56rem", margin: "0 auto" }}>
        <div
          style={{
            borderRadius: "16px",
            padding: "32px",
            background: "#FFFDF5",
            border: "1px solid #E8E6E3",
          }}
        >
          <div
            style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}
          >
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                background: "#ECFDF5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#22C55E"
                strokeWidth="2.5"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <div>
              <h3
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: "18px",
                  fontWeight: 700,
                  color: "#1A1814",
                  margin: "0 0 8px",
                }}
              >
                {t("flexibility.title")}
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#78736D",
                  margin: 0,
                  lineHeight: 1.6,
                }}
              >
                {t("flexibility.desc")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
